export default __webpack_public_path__ + "static/media/thunder.6fb1a7e8.svg";